import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";

import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const useFunilObraGrupoProduto = ({ formikRef = null, name = "funilObraGrupoProdutoId", showAll = false }) => {
  const funilObraGrupoProdutoSelect = useSelect("funilObraGrupoProdutos");
  const [fila, setFila] = useState(null);
  const [funilObraGrupoProduto, setFunilObraGrupoProduto] = useState(0);
  const [funilObraGruposProduto, setFunilObraGruposProduto] = useState([]);
  const [funilObraGrupoProdutoObjeto, setFunilObraGrupoProdutoObjeto] = useState({});

  useEffect(() => {
    const fetchGroup = async () => {
      let data = [];
      await db.funilObraGrupoProdutos.filter((a) => showAll || a.ativo).each((e) => data.push(e));

      setFunilObraGruposProduto(data);
    };

    fetchGroup();
  }, []);

  const optionFunilObraGruposProduto = useMemo(
    () => prepareForOptions(funilObraGruposProduto, "nome", "id"),
    [funilObraGruposProduto]
  );

  function onChangeFunilObraGrupoProduto(e) {
    funilObraGrupoProdutoSelect.upDateValue(e.value);
    funilObraGrupoProdutoSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue(name, e.value);
      setTimeout(() => formikRef.current.setFieldTouched(name, true));
    }
    setFunilObraGrupoProduto(e.value);
  }

  function SetSelectFunilObraGrupoProduto(id) {
    if (funilObraGruposProduto?.length) {
      const funilObraGrupoProduto = funilObraGruposProduto.find((grupo) => grupo.id === id);
      if (funilObraGrupoProduto)
        onChangeFunilObraGrupoProduto({
          value: funilObraGrupoProduto.id,
          label: funilObraGrupoProduto.nome,
        });

      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && funilObraGruposProduto?.length > 0) {
      SetSelectFunilObraGrupoProduto(fila);
    }

    if (funilObraGruposProduto?.length > 0) {
      setFunilObraGrupoProdutoObjeto(getColumnIntoKey({ data: funilObraGruposProduto, prefix: "id-" }));
    }
  }, [fila, funilObraGruposProduto]);

  function CleanForFilter(option) {
    onChangeFunilObraGrupoProduto(option);
  }

  return {
    funilObraGrupoProdutoObjeto,
    funilObraGruposProduto,
    optionFunilObraGruposProduto,
    onChangeFunilObraGrupoProduto,
    SetSelectFunilObraGrupoProduto,
    funilObraGrupoProduto,
    funilObraGrupoProdutoSelect,
    setFunilObraGrupoProduto,
    CleanForFilter,
  };
};

export default useFunilObraGrupoProduto;
